import { Link } from "react-router-dom";
import { Anchor, Wind, Mail, Phone } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_growth-capital-11/artifacts/4u4rtzwh_Copy%20of%20Blue%20Boat%20Sailing%20Logo%20%281%29.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy-950 text-white" data-testid="footer">
      <div className="px-6 md:px-12 lg:px-24 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6" data-testid="footer-logo">
              <img
                src={LOGO_URL}
                alt="Venture Winds"
                className="h-auto w-56 md:w-64" />

            </Link>
            <p className="text-slate-400 text-base leading-relaxed max-w-md mb-8">
              Strategic leadership and operational excellence for businesses 
              ready to transform. We partner selectively with companies that 
              share our vision for long-term value creation.
            </p>
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2 text-slate-400">
                <Anchor className="w-4 h-4 text-teal-500" />
                <span className="text-xs uppercase tracking-widest">Anchored in Excellence</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-6">Navigate</h4>
            <ul className="space-y-3">
              {[
              { name: "About", path: "/about" },
              { name: "Services", path: "/services" },
              { name: "Approach", path: "/approach" },
              { name: "Partnerships", path: "/partnerships" },
              { name: "Contact", path: "/contact" }].
              map((link) =>
              <li key={link.path}>
                  <Link
                  to={link.path}
                  className="text-slate-400 hover:text-teal-500 transition-colors text-sm uppercase tracking-wider"
                  data-testid={`footer-link-${link.name.toLowerCase()}`}>

                    {link.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-6">Connect</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:info@venturewinds.com"
                  className="flex items-center gap-3 text-slate-400 hover:text-teal-500 transition-colors"
                  data-testid="footer-email">

                  <Mail className="w-4 h-4" />
                  <span className="text-sm">info@venturewinds.com</span>
                </a>
              </li>
              <li>
                <a
                  href="tel:+1234567890"
                  className="flex items-center gap-3 text-slate-400 hover:text-teal-500 transition-colors"
                  data-testid="footer-phone">

                  <Phone className="w-4 h-4" />
                  <span className="text-sm">+1 ‪(929) 444-9026‬</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-xs uppercase tracking-widest">
            &copy; {currentYear} Venture Winds LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-slate-500">
            <Wind className="w-4 h-4" />
            <span className="text-xs uppercase tracking-widest">Navigating Success</span>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;